// eslint-disable
import React, { useEffect, useMemo } from 'react';
import Select from 'react-select';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { GET_MUNICIPALITIES } from './constant';
import { getMunicipalities } from './actions';

const makeListSelector = () => createSelector(
  ({ api }, name) => _.get(api, `${GET_MUNICIPALITIES}/${name}.list`) || [],
  (list) => list.map(item => ({
    label: _.get(item, 'attributes.name'),
    value: _.get(item, 'id'),
    fullInfo: item,
  }))
)

const Municipality = ({ name, regionCode, provinceCode, onChange, value, styles, readOnly, isDisabled }) => {

  const dispatch = useDispatch()
  const selectList = useMemo(makeListSelector, [])
  const isLoading = useSelector(({ api }) => api.loading.indexOf(`${GET_MUNICIPALITIES}/${name}`) > -1)
  const list = useSelector(state => selectList(state, name))

  const findValue = list.find(item => _.get(item, 'fullInfo.attributes.code') === value) || ''

  useEffect(() => {
    if(provinceCode)
      dispatch(getMunicipalities(name, regionCode, provinceCode))
  }, [provinceCode])

  return (
    readOnly === true ? 
      (
        <span className="full-input text-uppercase">
          {_.get(findValue, 'label')}
        </span>
      )
    :
      (
        <Select 
          placeholder="- Select -"
          isClearable
          isDisabled={isDisabled}
          isLoading={isLoading}
          styles={styles}
          value={findValue}
          onChange={onChange}
          options={provinceCode ? list : []}
          components={{
            IndicatorSeparator: () => null,
          }}
        />
      )
  )
}

Municipality.defaultProps = {
  name: undefined,
  styles: {},
  readOnly: undefined,
  isDisabled: false,
}

Municipality.propTypes = {
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  regionCode: PropTypes.string.isRequired,
  provinceCode: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  styles: PropTypes.instanceOf(Object)
}

export default Municipality